import React from 'react';

import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Actions from './components/Actions';
import {
  getMessage,
  getStatus,
  getLocalFormattedTime,
  getAssignee
} from './utils';

const Row = ({ order, index, fetchOrders }) => {
  const {
    orderId,
    iotCompanyName,
    iotProductSelected,
    iotActivationOrRenwal,
    iotNewOrExisting,
    createdAt
  } = order;
  const { statusToolTip, statusId } = getStatus(order);
  const {
    orderAssignedTo,
    channelName,
    first_name: firstName,
    last_name: lastName
  } = order;

  return (
    <Tr style={{ background: index % 2 === 0 ? '#f9f1ff' : '#ffffff' }}>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{orderId}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{channelName}</Td>
      <Td
        style={{ borderRight: '1px solid #e7e7e7' }}
      >{`${firstName} ${lastName}`}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{iotCompanyName}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{iotProductSelected}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {iotActivationOrRenwal}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{iotNewOrExisting}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getLocalFormattedTime(createdAt)}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{statusToolTip}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getAssignee(orderAssignedTo)}
      </Td>
      <Td style={{ width: '15%', borderRight: '1px solid #e7e7e7' }}>
        {getMessage(order)}
      </Td>
      <Td style={{ width: '30%', borderRight: '1px solid #e7e7e7' }}>
        <Actions status={statusId} order={order} fetchOrders={fetchOrders} />
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
